import React, { Component, Fragment } from 'react';
import CustomAlert from '../ui/CustomAlert';
import StickyBlock from './StickyBlock';

const withAlert = WrappedComponent => {
  return class extends Component {
    state = {
      show: false,
      alertType: '',
      message: '',
      dismissable: true,
    };

    showAlert = params => {
      this.setState(prevState => ({
        show: true,
        ...params,
      }));
    };

    closeAlert = () => {
      this.setState(prevState => ({
        show: false,
        alertType: '',
        message: '',
        dismissable: true,
      }));
    };

    render() {
      const { show } = this.state;

      return (
        <Fragment>
          {show && (
            <StickyBlock>
              <div className="alert-notifications-wrapper">
                <CustomAlert params={this.state} onClose={this.closeAlert} />
              </div>
            </StickyBlock>
          )}
          <WrappedComponent
            {...this.props}
            showAlert={this.showAlert}
            closeAlert={this.closeAlert}
          />
        </Fragment>
      );
    }
  };
};

export default withAlert;
